import React from 'react';
import Notifications from '../components/Notifications';
import Support from '../components/support/Support';
import UserIcon from '../components/UserIcon';
import SessionManager from '../routes/SessionManager';
import CommonUtils from '../util/CommonUtils';
import SubmitCaseModal from '../components/modals/SubmitCaseModal';

var Navigator = {};
var navigation = {
    "default": [
        {
            'id': '01',
            'className': 'navbar-nav ml-auto mt-2 mt-lg-0',
            nav: [
                { id: '01-01', path: '/login', name: <span className='pr-5'><i className='fa fa-lg fa-sign-in'></i> Login</span> },
                { id: '01-02', path: '/facebook', name: <i className='fa fa-lg fa-facebook-square spacer'></i> },
                { id: '01-03', path: '/facebook', name: <i className='fa fa-lg fa-instagram spacer'></i> },
                { id: '01-04', path: '/facebook', name: <i className='fa fa-lg fa-linkedin-square spacer'></i> }
            ]
        }
    ],
    "app": [
        {
            'id': '00',
            'auth': true,
            'className': 'navbar-nav mr-auto mb-1 px-md-0 px-2 mt-lg-0',
            nav: [
                { id: '00-01', path: '/dashboard', name: 'Dashboard', permission: 'SITESUPT-UI-DASHBOARD-SITES' },
                { id: '00-01-01', path: '/dashboard-exec', name: 'Executive Dashboard', permission: 'SITESUPT-UI-EXEC-DASHBOARD' },
                { id: '00-02', path: '/sensors-dashboard', name: 'Sensors Dashboard', permission: 'SITESUPT-UI-SENSOR-DASHBOARD' },
                { id: '00-03', path: '/sitemap', name: 'Site Map', permission: 'SITESUPT-UI-DASHBOARD-SITEMAP' },
                { id: '00-04', path: '/map-view', name: 'Map View', permission: 'SITESUPT-UI-MAPVIEW' },
                { id: '00-05', path: '/owners-portal', name: 'Owners Portal', permission: 'SITESUPT-UI-OWNERS-PORTAL' },
                { id: '00-06', path: '/timelapse-dashboard', name: 'Timelapse Dashboard', permission: 'SITESUPT-UI-TIMELAPSE-DASHBOARD' },
                { id: '00-07', path: '/site-management', name: 'Site Management', permission: 'SITESUPT-UI-SITE-MGMT' },
                { id: '00-08', path: '/bim-models', name: 'BIM Viewer', permission: 'SITESUPT-UI-BIM-VIEWER' },
                { id: '00-09', path: '/reports', name: 'Reports', permission: 'SITESUPT-UI-REPORTS' },
                { id: '00-10', path: '/videos', name: 'Videos', 'no-nav-paths': ['timelapse-video', 'video-library'], permission: 'SITESUPT-UI-VIDEOS' },
                {
                    id: '00-11', name: 'Support',
                    nav: [
                        { id: '00-11-01', name: <Support>Email: support@sitekick.com</Support> },
                        { id: '00-11-02', path: 'tel:612-605-3170', name: 'Phone: 612-605-3170' },
                        { id: '00-11-03', path: '/support/how-to-videos', name: 'How To Videos' },
                        { id: '00-11-04', path: '/support/faqs', name: 'FAQ' },
                        { id: '00-11-05', path: '/support/third-party-monitoring', name: 'Third Party Monitoring', },
                        { id: '00-11-06', name: <SubmitCaseModal>Submit A Case</SubmitCaseModal> }
                    ]
                }
            ]
        },
        {
            'id': '01',
            'auth': true,
            'className': 'navbar-nav ml-auto mt-2 px-2 mt-lg-0',

            nav: [
                { id: '01-01', name: <Notifications />, path: "/", mobile_mode: false },
                {
                    id: '01-02', name: <UserIcon></UserIcon>,
                    nav: [
                        { id: '01-02-01', path: '/profile-settings', name: <span className='pr-5'><i className='fa fa-lg fa-cog'></i> Settings</span>, permission: "SITESUPT-UI-USER-SETTINGS" },
                        { id: '01-02-02', path: '/admin-console', name: <span className='pr-5'><i className="fa fa-lg fa-user"></i>&nbsp; Admin</span>, permission: "SITESUPT-UI-ADMIN-CONSOLE" },
                        { id: '01-02-03', path: '/logout', name: <span className='pr-5'><i className='fa fa-lg fa-sign-out-alt'></i> Logout</span> }
                    ]
                }
            ]
        }
    ],
    "app-zero-sites": [
        {
            'id': '00',
            'auth': true,
            'className': 'navbar-nav mr-auto mb-1 px-2 mt-lg-0',
            nav: [
                {
                    id: '00-04', name: 'Support',
                    nav: [
                        { id: '00-04-01', name: <Support>Email: support@sitekick.com</Support>, },
                        { id: '00-04-02', path: 'tel:612-605-3170', name: 'Phone: 612-605-3170', },
                        { id: '00-04-03', path: 'support/how-to-videos', name: 'How To Videos', },
                        { id: '00-04-04', path: 'support/faqs', name: 'FAQ', }
                    ]
                }
            ]
        },
        {
            'id': '01',
            'auth': true,
            'className': 'navbar-nav ml-auto mt-2 px-2 mt-lg-0',
            nav: [
                { id: '01-01', name: <Notifications />, path: "/", mobile_mode: false },
                {
                    id: '01-02', name: <UserIcon></UserIcon>,
                    nav: [
                        // { id: '01-02-01', path: '/profile-settings', name: <span className='pr-5'><i className='fa fa-lg fa-cog'></i> Settings</span> },
                        { id: '01-02-02', path: '/admin-console', name: <span className='pr-5'><i className="fa fa-lg fa-user"></i> Admin</span>, permission: "SITESUPT-UI-ADMIN-CONSOLE" },
                        { id: '01-02-03', path: '/logout', name: <span className='pr-5'><i className='fa fa-lg fa-sign-out-alt'></i> Logout</span> }
                    ]
                }
            ]
        }
    ]
};

Navigator.getNav = (key) => {
    if (key === 'app') {
        let sm = new SessionManager();
        let u = sm.readCookie('user', false);

        let actv_sites = [];
        let inactive_sites = [];
        if (u && u.site_locations !== undefined) {
            actv_sites = u.site_locations.filter(site => site.site_state.trim().toUpperCase() !== 'INACTIVE');
            inactive_sites = u.site_locations.filter(site => site.site_state.trim().toUpperCase() === 'INACTIVE');
        }
        if (actv_sites.length === 0 && (inactive_sites.length > 0 && !CommonUtils.hasPermission('SITESUPT-UI-ALLOW-INACTIVE-SITES')))
            key = 'app-zero-sites';

        //console.log('Key', key);
    }
    return navigation[key];
}

export default Navigator;